import { useEffect, useState } from "react";

import SimpleDialog from "components/SimpleDialog";
import { Typography } from "@mui/material";
import PepperChat from "assets/images/pepper_chat.svg";
import { fireAuth, firestore, functions } from "lib/firebase";
import { instanceIdAtom } from "lib/globalState";
import { useRecoilValue } from "recoil";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { useHistory, useLocation } from "react-router";
import { currentAppAtom } from "../lib/globalState";

let tm = null;

const AltroUtenteModal = () => {
	const [openModal, setOpenModal] = useState(false);
	const instanceId = useRecoilValue(instanceIdAtom);
	const appId = useRecoilValue(currentAppAtom);
	const [queueCount] = useDocumentData(firestore.doc(`/apps/${appId}/waiting_queue/${instanceId}`));
	const {pathname} = useLocation();
	const [timerRunning, setTimerRunning] = useState(false);
	const ignorePaths = ["/fine", `/instanceid/${instanceId}`];
	const history = useHistory();

	const expireToken = () => {
		try {
			const expireTokenF = functions.httpsCallable("areax_expireToken");
			expireTokenF({instanceId})
			.then((result) => {
				const {success, error} = result.data;
				if (success) {
					console.log("token expire ok");
					fireAuth.signOut();
				} else {
					console.log(error);
				}
			});
		} catch (e) {
			console.log(e);
		}
	};

	const onContinue = () => {
		setOpenModal(false);
	};

	const onCancel = () => {
		history.push("/fine");
	};

	useEffect(() => {
		if (!ignorePaths.includes(pathname) && queueCount?.count && queueCount.count === 1) {
			setOpenModal(true);
			setTimerRunning(true);
		}
	}, [queueCount]);

	useEffect(() => {
		if (timerRunning) {
			tm = setTimeout(() => {
				setOpenModal(false);
				expireToken();
			}, 30 * 1000);
		} else {
			tm && clearTimeout(tm);
		}
		return () => tm && clearTimeout(tm);
	}, [timerRunning]);

	useEffect(() => {
		if (!openModal) {
			setTimerRunning(false);
			tm && clearTimeout(tm);
		}
	}, [openModal]);

	return <SimpleDialog
		open={openModal}
		title="Un altro utente vorrebbe interagire con Pepper!"
		onConfirm={onContinue}
		onCancel={onCancel}
		headerImage={PepperChat}
		cancelLabel="Esci"
		onClose={() => setOpenModal(false)}
	>
		<Typography>Ti rimangono pochi minuti! Scegli “Continua” se vuoi proseguire
			nell’esperienza, altrimenti scegli “Esci”
			per salutare Pepper.</Typography>
	</SimpleDialog>;
};

export default AltroUtenteModal;